import styled from 'styled-components'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Image = styled.img`
  width: 100px;
  height: 100px;
  box-shadow: 0px 2px 10px -6px #252525;
  border-radius: 20px;
  margin-bottom: 15px;
`

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
`

export const ButtonColumn = styled(Block)`
  gap: 10px;
  margin-bottom: 0px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  flex-direction: row;
  align-items: flex-start;
  gap: 7px;
`

export const TabRow = styled(Row)`
  width: 100%;
  padding-top: 2px;
  margin-bottom: 10px;
  z-index: 9;
  gap: 10px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const MoneyText = styled(SubTitle)`
  color: #44CF6C;
`

export const LinkText = styled.a`
  color: #35A7FF;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-decoration: none;
  width: 480px;

  &:hover {
    color: #2875E2;
  }
`
export const SmallButton = styled(LookButton).attrs(buttonLook({ variant: 'ghost' }))`
  gap: 5px;
`
